// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"e_Zw","title":"e__w","container":"e_0w","list":"e_1w"};